import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext } from "react";
export var AppFloorPlanContext = createContext({});
export var AppFloorPlanContextProvider = function (_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(AppFloorPlanContext.Provider, {
    value: props
  }, children);
};
AppFloorPlanContextProvider.displayName = "AppFloorPlanContextProvider", AppFloorPlanContextProvider.__docgenInfo = {
  description: "A provider for the AppFloorPlanContext, allowing AppFloorPlan props default values\nto be managed from the context, for example, when embedded in micro-apps",
  methods: [],
  displayName: "AppFloorPlanContextProvider"
}, AppFloorPlanContextProvider.__docgenInfo = {
  componentName: "AppFloorPlanContextProvider",
  packageName: "@jutro/floorplan",
  description: "A provider for the AppFloorPlanContext, allowing AppFloorPlan props default values\nto be managed from the context, for example, when embedded in micro-apps",
  displayName: "AppFloorPlanContextProvider",
  methods: [],
  actualName: "AppFloorPlanContextProvider"
};